import React from "react";
import Link from "@amzn/meridian/link";
import { getStationCode } from "../network/NetworkUtil";
import { FormattedMessage } from "react-intl";
import packageIcon from "../labs/assets/package.png";
import { getDomain, getRegion } from "../util/Util";
import Card from "@amzn/meridian/card";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import Column from "@amzn/meridian/column";
import Image from "@amzn/meridian/image";
import { INTEG, MASTER } from "../util/Constants";

const getRedirectLink = () => {
  const domain = getDomain();
  let baseUrl = "";
  const date = new Date().toISOString().slice(0, 10);
  if (domain === INTEG) {
    baseUrl =
      getRegion() === "na"
        ? "ui.package-summary"
        : getRegion() === "jp"
          ? "ui.package-summary-fe-integ"
          : "ui.package-summary-eu-integ";
  } else if (domain === MASTER) {
    baseUrl =
      getRegion() === "na"
        ? "ui.package-summary-na-master"
        : getRegion() === "jp"
          ? "ui.package-summary-fe-master"
          : getRegion() === "in"
            ? "ui.package-summary-in-master"
            : "ui.package-summary-eu-master";
  } else {
    baseUrl =
      getRegion() === "na"
        ? "ui.package-summary-na"
        : getRegion() === "jp"
          ? "ui.package-summary-fe"
          : getRegion() === "in"
            ? "ui.package-summary-in"
            : "ui.package-summary-eu";
  }
  baseUrl = "https://" + baseUrl + ".last-mile.amazon.dev/";
  const endpoint =
    "?stationCode=" +
    getStationCode() +
    "&cycleId=AllCycles#dwellingBoard/{}/sensitivePackageSearch/";
  const parameter =
    "{%22cycles%22:[],%22startPDD%22:%22" +
    date +
    "%22,%22endPDD%22:%22" +
    date +
    "%22,%22packageTypes%22:[%22Core%20Volume%22],%22packageStatuses%22:[%22Sensitive%20Packages%22],%22dwellEndTime%22:%22TOTAL%22,%22page%22:%22AGEING%22}";
  return baseUrl + endpoint + parameter;
};

const LabsView = () => {
  return (
    <Column spacing="small" spacingInset="medium large none large">
      <Card width={350} spacingInset="none">
        <Image
          src={packageIcon}
          size="auto 100%"
          viewportAspectRatio={3 / 2}
          viewportBackgroundColor="#cde8f1"
          viewportSpacingInset={64}
        />
        <Column spacingInset="400 500" spacing="300">
          <Heading level={4} type="h200">
            <Link href={getRedirectLink()} type="secondary">
              <FormattedMessage
                id="labs.userSensitive"
                defaultMessage="Sensitive Customer Packages"
              />
            </Link>
          </Heading>
          <Text type="b200">
            <FormattedMessage
              id="labs.userSensitive.desc"
              defaultMessage="'Sensitive Customers' are the customers who experienced repeated failed deliveries or late deliveries in the recent past. This tool here surfaces those packages that belong to such sensitive customers who did not get their deliveries on time in the past due to missed on-time dispatch. If you see any packages here today, please ensure that those packages get staged on time and are picked up by the drivers. That will convert those 'sensitive customers' to 'happy customers'."
            />
          </Text>
        </Column>
      </Card>
    </Column>
  );
};

export default LabsView;



// WEBPACK FOOTER //
// ./src/components/labs/LabsView.js